import { StepProps, StepItem } from "antd";
import { PropsWithChildren } from "react";
import { StyledSteps } from "./atom";

export type RenderbusStepsProps = PropsWithChildren<
  StepProps & {
    items: StepItem;
    current?: number;
    direction?: string;
  }
>;

export function Steps({
  className = "",
  current,
  direction = "vertical",
  ...props
}: RenderbusStepsProps) {
  return (
    <StyledSteps
      className={`renderbus-ui--steps ${className}`}
      current={current}
      direction={direction}
      {...props}
    />
  );
}
